import { type ReactNode, useState } from 'react';
import { clsx } from 'clsx';
import { Box } from '@repo/ui/Box';
import { Flex } from '@repo/ui/Flex';
import { IconButton } from '@repo/ui/IconButton';

import s from './Collapsible.module.css';

interface CollapsibleProps {
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
  header?: ReactNode;
  children: ReactNode;
  collapsed?: boolean;
}

export const Collapsible = (props: CollapsibleProps) => {
  const {
    className,
    header,
    children,
    collapsed = false,
    headerClassName,
    contentClassName,
  } = props;
  const [isOpen, setIsOpen] = useState(!collapsed);

  return (
    <Box className={clsx(s.container, className)}>
      <Flex
        className={clsx(s.header, isOpen && s.isOpen, headerClassName)}
        alignItems="center"
        justifyContent="space-between"
      >
        {header}
        <IconButton
          className={clsx({ [s.chevron]: true, [s.chevronDown]: !isOpen })}
          aria-expanded={isOpen}
          icon="chevron-up"
          label="Toggle"
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(!isOpen);
          }}
          variant="tertiary"
        />
      </Flex>
      {isOpen && (
        <Box className={clsx(s.contents, contentClassName)}>{children}</Box>
      )}
    </Box>
  );
};
